<template>
  <div class="phone">
    <PhoneIcon :class="{ inactive: !active }" />
  </div>
</template>

<script>
import PhoneIcon from '~/assets/svg/phone.svg?component'

export default {
  components: {
    PhoneIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
  .phone
    :deep(svg)
      &.inactive
        path:nth-child(1)
          fill: #D1D1D1
          stroke: #D1D1D1
</style>
